module.exports = __webpack_public_path__ + "static/media/aboutus@2x.7f6768ab.jpg";